import { Modal, Form, Tooltip } from 'antd';
import React, { useState, useEffect } from 'react';
import { SolicitacaoParaConluirSla } from '@app/api/sla';
import { Button, Icon } from '@digital/ui';
import TextArea from 'antd/lib/input/TextArea';

export interface PropsModalComentario {
  id: string;
  onUpdatePage: () => any;
}

const ModalJustificativaSolicitacaoConcluirSla = (props: PropsModalComentario) => {
  const { id, onUpdatePage } = props;
  const [exibirModal, setExibirModal] = useState(false);
  const textAreaId = `textAreaId${id}`;
  const [justificativa, setJustificativa] = useState('');

  const limparCampo = () => {
    const elemento = document.getElementById(textAreaId);
    if (elemento != null) {
      document.getElementById(textAreaId).value = '';
    }
  };

  const showModal = () => {
    limparCampo();
    setExibirModal(true);
  };

  const handleCancel = () => {
    limparCampo();
    setExibirModal(false);
  };

  const Salvar = (e: any) => {
    SolicitacaoParaConluirSla({ medicaoId: id, justificativa: justificativa }).then(data => {
      if (data) {
        limparCampo();
        onUpdatePage();
      }
    });
  };

  return (
    <>
      <Tooltip title="Solicita conclusão sumária do SLA, SEM APLICAR OS VALORES em nenhuma medição posterior.">
        <Button
          type="link"
          icon="ui-approve_and_update"
          confirm="Solicita conclusão sumária do SLA, SEM APLICAR OS VALORES em nenhuma medição posterior."
          onClick={() => {
            showModal();
          }}>
          Solicitar Conclusão
        </Button>
      </Tooltip>

      <Modal
        title="Justificativa da solicitação para concluir medição"
        className="chat-modal"
        visible={exibirModal}
        onCancel={() => {
          handleCancel();
        }}
        footer={[
          <Button key="submit" type="link" onClick={e => Salvar(e)}>
            Enviar
          </Button>,
          <Button key="cancel" type="primary" onClick={() => handleCancel()}>
            Fechar
          </Button>,
        ]}>
        <TextArea
          name="justificativa"
          id="justificativa"
          onChange={value => {
            setJustificativa(value.currentTarget.value);
          }}
          placeholder="informe a justificativa"
          rows={3}
        />
      </Modal>
    </>
  );
};

export default ModalJustificativaSolicitacaoConcluirSla;
